import styled from 'styled-components'

const Page = styled.div`
  .help-center-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    padding: 1rem 0;
    
    .search-container {
      flex: 1;
      max-width: 500px;
      margin-left: 2rem;
      position: relative;
      
      .search-input {
        width: 100%;
        padding: 0.75rem;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
        
        &:focus {
          outline: none;
          border-color: #007bff;
          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
        }
      }
      
      .search-results {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ddd;
        border-radius: 4px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        max-height: 400px;
        overflow-y: auto;
        
        h3 {
          padding: 1rem;
          margin: 0;
          border-bottom: 1px solid #eee;
          font-size: 16px;
          color: #333;
        }
      }
    }
  }
  
  .video-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
    margin-top: 2rem;
    
    .video-card {
      border: 1px solid #eee;
      border-radius: 8px;
      padding: 1rem;
      background: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      
      h4 {
        margin: 0 0 0.5rem 0;
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }
      
      p {
        margin: 0 0 1rem 0;
        color: #666;
        font-size: 14px;
        line-height: 1.4;
      }
      
      .video-iframe {
        width: 100%;
        border-radius: 4px;
        overflow: hidden;
        
        iframe {
          border-radius: 4px;
        }
      }
    }
  }
  
  @media (max-width: 768px) {
    .help-center-top {
      flex-direction: column;
      align-items: stretch;
      
      .search-container {
        margin-left: 0;
        margin-top: 1rem;
      }
    }
    
    .video-grid {
      grid-template-columns: 1fr;
      gap: 1rem;
    }
  }
`

const Content = styled.div`
  line-height: 20px;
  @media (max-width: 768px) {
    margin-left: 0rem;
    padding: 1rem;
  }
`

Content.Heading = styled.h1`
  text-align: center;
  margin-bottom: 1.6rem;
  line-height: 28px;
  color: #333333;
  font-weight: 600;
`

Content.Video = styled.div`
  margin-left: -15rem;
  margin-bottom: 4rem;
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    margin-left: 0rem;
  }
`

Content.Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #67686e;
`

Content.Label = styled.span`
  margin-right: 20px;
  color: #000;
`

Content.Flex = styled.span`
  display: flex;
  margin-top: 30px;

  button {
    border-radius: 5px;
  }
`

Content.Form = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  max-width: 50%;

  input {
    margin-bottom: 20px;
  }

  input,
  p,
  label {
    color: #333333;
  }

  .required-warning {
    border: 1px solid red;
  }

  .required-warning-text {
    color: red;
    font-size: 0.75em;
  }

  .form-footer {
    display: flex;
    justify-content: flex-end;

    button {
      margin-left: 20px;
      border-radius: 5px;
      min-width: 132px;
    }
  }
`

export { Page, Content }
